import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { timeout, map } from 'rxjs/operators';

const mainUrl = environment.url;

@Injectable({
  providedIn: 'root'
})
export class LinkService {

  constructor(private http: HttpClient) { }

  getAllLinks(): Observable<any> {
    return this.http.get(mainUrl + 'param-link')
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  createLink(form): Observable<any> {
    return this.http.post(mainUrl + 'param-link', form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getLinkById(id): Observable<any> {
    return this.http.get(mainUrl + 'param-link/' + id)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  updateLink(id, form): Observable<any> {
    return this.http.put(mainUrl + 'param-link/' + id, form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  deleteLink(id): Observable<any> {
    return this.http.delete(mainUrl + 'param-link/' + id)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getHeader() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': window.localStorage.getItem('token')
     });

    return headers;
  }
}